import { defineComponent } from "vue";
import Tuple from "@common/vue/Tuple.vue";
import InlineSvg from "vue-inline-svg";
import Dot from "@common/vue/Dot.vue";
import { liveStore } from "@live/store/LiveStore";
import { FLICK_TARGET_SWITCH, SET_IS_FLIGHT_FOCUS } from "@live/store/LiveMutations";
import { SET_CURRENT_FLIGHT_BY_ID } from "@live/store/LiveActions";
export default defineComponent({
    components: {
        Tuple,
        InlineSvg,
        Dot
    },
    computed: {
        airportDetail: function () {
            const airportDetail = liveStore.getters.getCurrentAirportDetail;
            return airportDetail;
        },
        airportName: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.name : "Unknown Name";
        },
        airportTitle: function () {
            const airportDetail = this.airportDetail;
            if (airportDetail == null) {
                return `???? | ???`;
            }
            let icao = airportDetail.icao.trim();
            if (icao == "") {
                icao = "????";
            }
            let iata = airportDetail.iata.trim();
            if (iata == "") {
                iata = "???";
            }
            return `${icao} | ${iata}`;
        },
        imageSrc: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.imageSrc : "img/404.webp";
        },
        atis: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.atis : "Not Available";
        },
        isGroundActive: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.hasGround : false;
        },
        isTowerActive: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.hasTower : false;
        },
        isApproachActive: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.hasApproach : false;
        },
        isDepartureActive: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.hasDeparture : false;
        },
        departures: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.departures : [];
        },
        arrivals: function () {
            const airportDetail = this.airportDetail;
            return airportDetail != null ? airportDetail.arrivals : [];
        },
    },
    methods: {
        onFullScreen: function () {
            this.$emit("onFullScreen");
        },
        onFlightClick: async function (id) {
            liveStore.commit(SET_IS_FLIGHT_FOCUS, true);
            await liveStore.dispatch(SET_CURRENT_FLIGHT_BY_ID, { id });
            liveStore.commit(FLICK_TARGET_SWITCH);
        }
    },
    emits: ["onFullScreen"]
});
